module.exports = __webpack_public_path__ + "img/23.3816b64e.jpg";